import api from './api';

export interface AnalysisProgress {
  solution_id: string;
  status: 'running' | 'completed' | 'failed';
  current_step: string;
  claims_total: number;
  claims_processed: number;
  documents_total: number;
  documents_processed: number;
  current_document_id: string | null;
  error_message: string | null;
  started_at: string;
  updated_at: string;
}

export interface PartialResult {
  solution_id: string;
  claim_index: number;
  document_id: string;
  verdict: 'novel' | 'anticipated';
  is_novel: boolean;
  confidence: number;
  rationale: string;
  created_at: string;
}

const BASE = '/api/patent-analysis/patentability';

export const patentabilityAnalysisService = {
  launch: async (subProjectId: string, solutionId: string): Promise<{ status: string; message: string }> => {
    const { data } = await api.post(`${BASE}/launch`, {
      sub_project_id: subProjectId,
      solution_id: solutionId,
    });
    return data;
  },

  getProgress: async (subProjectId: string, solutionId: string): Promise<AnalysisProgress> => {
    const { data } = await api.get<AnalysisProgress>(`${BASE}/progress/${solutionId}?sub_project_id=${subProjectId}`);
    return data;
  },

  getPartialResults: async (subProjectId: string, solutionId: string): Promise<PartialResult[]> => {
    const { data } = await api.get<PartialResult[]>(`${BASE}/partial-results/${solutionId}?sub_project_id=${subProjectId}`);
    return data;
  },

  getReport: async (subProjectId: string, solutionId: string): Promise<Record<string, unknown>> => {
    const { data } = await api.get(`${BASE}/reports/${solutionId}?sub_project_id=${subProjectId}`);
    return data;
  },
};
